/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

'use strict';

import React from 'external/react';
import PropTypes from 'external/prop-types';
import { Title } from 'plugin/liferay-widgets-react-web';
import { PropertyBox } from './DetailsRenderer';
import ItemDescription from './ItemDescription';

import { Row } from 'external/react-bootstrap';
import { ElementTypes } from '../constants/Constants';

const FliwasDetailsBox = ({ item, propertyDescriptions, boxGridSize = 4, children }) => {
    item = item && (item.item || item);

    if (!item) {
        return <div>Kein Element gewählt</div>;
    }

    let elements;

    const chunks = (arr, size) => {
        let result = [];

        for (let i = 0 ; i < arr.length ; i += size) {
            result.push(arr.slice(i, size + i));
        }

        return result;
    };

    elements = React.Children.map(children, (child) => {
        if (child !== null && child.props && child.props.elementType === ElementTypes.PropertyBox) {
            return child;
        }
    }) || [];

    const reducer = (accumulator, currentValue, currentIndex) => {
        return (
            accumulator.concat(<Row className="border-box" key={ currentIndex }>{ currentValue }</Row>)
        );
    };

    const rows = chunks(elements, 12 / boxGridSize);

    return (
        <React.Fragment>
            { item && item.title &&
                <Title title={ item.title }/>
            }
            { item.description && item.description.length > 0 && <Row className="border-box">
                <PropertyBox title={ 'Beschreibung' } boxGridSize={ 12 }>
                    <ItemDescription item={ item }/>
                </PropertyBox>
            </Row> }
            {
                rows.reduce(reducer, [])
            }
        </React.Fragment>
    );
};

FliwasDetailsBox.propTypes = {
    item: PropTypes.object,
    propertyDescriptions: PropTypes.object,
    children: PropTypes.node,
    boxGridSize: PropTypes.number
};

export default FliwasDetailsBox;



// WEBPACK FOOTER //
// ./js/components/FliwasDetailsBox.jsx